import { Field } from 'app/interfaces/fields';
import { GlobalService } from './global.service';
import { Block } from 'app/interfaces/blocks';
import { AppInjector } from 'app/app.module';
import { SigningHelperService } from 'app/main/signing-pages/signing-page/signing-page-helper';
import { SelectedFieldBlock } from 'app/interfaces/fields.dto';
import { ContentResizeService } from './content-resizable/content-resizable.service';
import { generateCalculation } from './calculation';


/**
 * apply the relation when current field change event fire
 * @param uuid 
 * @param globalService 
 */
export function applyRelations(uuid: string|number, globalService: GlobalService, stopInfinity = false) {
    const field: Field = globalService.fields_data[uuid];
    if (
        Object.prototype.hasOwnProperty.call(field, 'linked_conditional_id') &&
        Array.isArray(field.linked_conditional_id)
    ) {
        for (const linked_id of field.linked_conditional_id) {
        applyRelationsOnCurrent(linked_id, globalService, stopInfinity);
        }
    }
}


/**
 * apply the relation on currect field come from applyRelations function
 * @param uuid 
 * @param globalService 
 * @param stopInfinity 
 */
export function applyRelationsOnCurrent(uuid: string|number, globalService: GlobalService, stopInfinity = false) {
    let props = {};
    try {
        let field: Field = globalService.fields_data[uuid];
        if (typeof field == 'undefined') {
            field = globalService.fields_data['blocks'][uuid];
        }
        let conditional = false;
        if(field){
            if (Array.isArray(field?.connected_parent_conditional_id)) {
                for (const connected_parent of field.connected_parent_conditional_id) {
                    const connectedField: Field = globalService.fields_data[['droplist', 'list'].includes(connected_parent.type) ? connected_parent.main_uuid : connected_parent.uuid];
                    const option = connectedField?.options?.find(opt => opt.name == connected_parent.name);
                    if (typeof connectedField !== 'undefined' && (connected_parent.type == 'droplist' && (!connectedField?.multi_select || connectedField?.multi_select === 0) && (connectedField?.value == connected_parent.name || connectedField?.value == option?.value))) {
                        conditional = true;
                        break;
                    } else if (typeof connectedField !== 'undefined' && ['list', 'droplist'].includes(connected_parent.type)) {
                        if (connectedField?.multi_choice == "1" || connectedField?.multi_select === 1) {
                            if (connectedField?.value && (connectedField?.value?.includes(connected_parent?.name) || connectedField?.value?.includes(option?.value))) {
                                conditional = true;
                                break;
                            }
                        } else if (connectedField?.multi_choice == "0" && (connectedField?.value == connected_parent.name || connectedField?.value == option?.value)) {
                            conditional = true;
                            break;
                        }
                    } else if (typeof connectedField !== 'undefined' && (connected_parent.type != 'droplist' && connected_parent.type != 'list' && connectedField?.value)) {
                        conditional = true;
                        break;
                    } else {
                        conditional = false;
                    }
                }
            }

            if (field?.connected_parent_conditional_id.length == 0 || conditional) {
                if (['content-box', 'form-builder', 'table', 'attachment', 'upload-pdf', 'image', 'page-break'].includes(field.type)) {
                    props = { type: 'block', uuid: uuid };
                    (document.querySelectorAll('.editor' + uuid)).forEach((editor: HTMLElement) => {
                        editor.classList.remove('hidden');
                        editor.closest('.rowItem').classList.remove('has-relation');
                    });
                    (document.querySelectorAll(`.page-break[uuid="${uuid}"]`)).forEach((pageBreak: HTMLElement) => {
                        hideTheElement(false, pageBreak);
                    });
                    globalService.updateBlock(uuid, { hidden: 0 });
                } else {
                    props = { type: 'field', uuid: uuid };
                    document.querySelectorAll('.drag-fields[uuid="' + uuid + '"]').forEach((field: HTMLElement) => {
                        field.classList.remove('hidden')
                    });
                    if (Number(field.field_block) === SelectedFieldBlock.ContentField) {
                        document.querySelectorAll('.drag-fields[uuid="' + uuid + '"]').forEach((field: HTMLElement) => {
                            (field.closest('.rowItem') as HTMLElement).classList.remove('has-relation');
                        });
                    }
                    globalService.updateField(uuid, { hidden: 0 });
                }
            } else {
                if (['content-box', 'form-builder', 'table', 'attachment', 'upload-pdf', 'image', 'page-break'].includes(field.type)) {
                    props = { type: 'block', uuid: uuid };
                    (document.querySelectorAll(`.editor${uuid}`)).forEach((editor: HTMLElement) => {
                        editor.classList.add('hidden');
                        editor.closest('.rowItem').classList.add('has-relation');
                    });
                    (document.querySelectorAll(`.page-break[uuid="${uuid}"]`)).forEach((pageBreak: HTMLElement) => {
                        hideTheElement(true, pageBreak);
                    });
                    globalService.updateBlock(uuid, { hidden: 1 });
                } else {
                    props = { type: 'field', uuid: uuid };
                    globalService.resetField(uuid, 1);
                    document.querySelectorAll('.drag-fields[uuid="' + uuid + '"]').forEach((field: HTMLElement) => {
                        field?.classList?.add('hidden');
                        const hasCalculation = field?.querySelector('.calculation');
                        if (hasCalculation) {
                            generateCalculation(uuid, globalService, true);
                        }
                    });
                    if (Number(field.field_block) === SelectedFieldBlock.ContentField) {
                        document.querySelectorAll('.drag-fields[uuid="' + uuid + '"]').forEach((field: HTMLElement) => {
                            (field.closest('.rowItem') as HTMLElement).classList.add('has-relation');
                        });
                    }
                }
            }
            if (!stopInfinity && !['content-box', 'form-builder', 'table', 'attachment', 'upload-pdf', 'image', 'page-break'].includes(field.type)) {
                applyRelations(uuid, globalService);
            }
            const signingHelperService = AppInjector?.get(SigningHelperService);
            signingHelperService?.updateListener(props);
            reinitializeContentResizing();
        }
    } catch (error) {
        console.warn(error);
    }
}

/**
 * reset the relation on the specific element
 * @param uuid 
 * @param globalService 
 */
export function resetRelation(uuid: string|number, globalService: GlobalService) {
    if (!globalService.fields_data?.['blocks']?.[uuid]) return;
    const block: Block = globalService.fields_data['blocks'][uuid];
    if(Array.isArray(block?.connected_parent_conditional_id)){
        for (const connected_parent of block.connected_parent_conditional_id) {
            const selectedUuid = ['droplist', 'list'].includes(connected_parent.type) ? connected_parent.main_uuid : connected_parent.uuid;
            const connectedField: Field = globalService.fields_data[selectedUuid];
            let linked_conditional_id = connectedField.linked_conditional_id;
            linked_conditional_id = linked_conditional_id.filter(function (item) { return item != uuid; });
            globalService.updateField(selectedUuid, { linked_conditional_id: linked_conditional_id });
        }
    }
    reinitializeContentResizing();
}

/**
 * reset the relation when conditional field is deleted
 * @param uuid 
 * @param globalService 
 */
export function resetDeletedRelation(uuid: string|number, globalService: GlobalService, callback?: () => void) {
    let field: Field = globalService.fields_data[uuid];
    if (field == undefined) {
        field = globalService.fields_data['blocks'][uuid];
    }
    if (field) {
        if(Object.prototype.hasOwnProperty.call(field, 'linked_conditional_id') && Array.isArray(field.linked_conditional_id)){
            for (const uuid of field.linked_conditional_id) {
                let field: Field = globalService.fields_data[uuid];
                if (field == undefined) {
                    field = globalService.fields_data['blocks'][uuid];
                }
                if (['content-box', 'form-builder', 'table', 'attachment', 'upload-pdf', 'image', 'page-break'].includes(field?.type)) {
                    (document.querySelector('.editor' + uuid) as HTMLElement)?.classList.remove('hidden');
                    (document.querySelector('.editor' + uuid) as HTMLElement)?.closest('.rowItem')?.classList?.remove('has-relation');
                    (document.querySelector(`.page-break[uuid="${uuid}"]`) as HTMLElement)?.classList.remove('hidden');
                    (document.querySelector(`.page-break[uuid="${uuid}"]`) as HTMLElement)?.closest('.rowItem')?.classList?.remove('has-relation');
                    globalService.updateBlock(uuid, { hidden: 0 });
                } else {
                    (document.querySelector('.drag-fields[uuid="' + uuid + '"]') as HTMLElement)?.classList?.remove('hidden');
                    if (Number(field?.field_block) === SelectedFieldBlock.ContentField) {
                        (document.querySelector('.drag-fields[uuid="' + uuid + '"]')?.closest('.rowItem') as HTMLElement)?.classList?.remove('has-relation');
                    }
                    globalService.updateField(uuid, { hidden: 0 });
                }
            }
        }
        reinitializeContentResizing();
    }
    if(callback){
        callback();
    }
}

function reinitializeContentResizing() {
    const contentResizeService = AppInjector?.get(ContentResizeService);
    contentResizeService?.initResizing();
}

function hideTheElement(toogle:boolean, element: HTMLElement) {
    if (toogle) {
        element.classList.add('hidden');
        element.closest('.rowItem')?.classList?.add('has-relation');
    } else {
        element.classList.remove('hidden');
        element.closest('.rowItem')?.classList?.remove('has-relation');
    }

}